import {FETCH_COMPANY} from "../../constant/ActionType";

export default function CompanyReducer(state = {
    companyData:[],
    statusCode: null,
}, action) {
    switch (action.type) {    
        case FETCH_COMPANY:
			return { ...state,
				companyData: action?.data ,
                statusCode:action.status
            };

        default:
    }
    return state;
}
